<template>
    <router-view v-if="!is404Page" ></router-view>
</template>

<script>
export default {
  name: "app",
  created() {
    let lang = localStorage.getItem("lang");
    if (!lang) {
      lang = navigator.language;
    }
    lang = "tr-TR";
    localStorage.setItem("lang", lang);
    this.$i18n.locale = lang;
    },
    computed: {
      // Check if the current route is the 404 page
      is404Page() {
        return this.$route.name === "Page404"; // Use the 404 route's name defined in your router
      },
    },
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~@fortawesome/fontawesome-free/webfonts/";
@import "~@fortawesome/fontawesome-free/scss/fontawesome.scss";
@import "~@fortawesome/fontawesome-free/scss/solid.scss";
@import "~@fortawesome/fontawesome-free/scss/regular.scss";
@import "~@fortawesome/fontawesome-free/scss/brands.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap/dist/css/bootstrap.css";
@import "~bootstrap-vue/dist/bootstrap-vue.css";

@import "~vodal/common.css";
@import "~vodal/zoom.css";

/* Import Multiselect Vue Styles */
@import "~vue-multiselect/dist/vue-multiselect.min.css";

// Import Main styles for this application
@import "assets/scss/style";

@import "~vue-toastification/dist/index.css";
.Vue-Toastification__toast--warning {
  color: #000000;
}

@import "~@voerro/vue-tagsinput/dist/style.css";

@import "~vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

</style>
